export default {
  // @Role
  newCreatedRole: {},
  // @Responsibility
  newCreatedRespo: {},
};
